import angular from "angular";
import { IHttpService, IPromise } from "angular";

interface IGridStateService {
    setItem(name: string, item: $TSFixMe): IPromise<$TSFixMe>;
    getItem(name: string, defaultValue?: $TSFixMe): IPromise<$TSFixMe>;
}

export class GridStateService implements IGridStateService {
    static componentName: string = "gridStateService";
    static $inject = ["$http"];

    constructor(private $http: IHttpService) {}

    setItem(name: string, item: $TSFixMe): IPromise<$TSFixMe> {
        return this.$http.put(`api/configuration/user-config-data/${name}`, item);
    }

    getItem(name: string, defaultValue: $TSFixMe = null): IPromise<$TSFixMe> {
        return this.$http
            .get(`api/configuration/user-config-data/${name}`)
            .then(request => (request.data ? request.data : defaultValue));
    }
}

angular
    .module("topline.modules")
    .factory(GridStateService.componentName, ["$http", ($http: IHttpService) => new GridStateService($http)]);